import React from "react";

import { searchStructuralUnits } from "@/api/one_c_pickers";
import { LoadState } from "@/lib/scan-ui/screen";
import { OrgWhitelistCard } from "@/pages/settings/cards/OrgWhitelistCard";
import { PalletPhotoCard } from "@/pages/settings/cards/PalletPhotoCard";
import { TemplateBindingsCard } from "@/pages/settings/cards/TemplateBindingsCard";
import { SettingsPageHeader } from "@/pages/settings/SettingsPageHeader";
import { useSystemSettingsQuery } from "@/pages/settings/useSystemSettingsQuery";
import { usePortalConfig } from "@/portal/usePortalConfig";

/** Настройки проверки заказов: фильтр организаций, склады-фулфилменты,
 *  паллетные листы и фотофиксация.
 *
 *  ⚠️ Склады-фулфилменты показываются только там, где ЕСТЬ проверка
 *  перемещений: настройка переключает перемещения на сборку паллетами, и без
 *  второго раздела переключать нечего. */
export function OrderCheckSettingsPage(): React.ReactElement {
  const { hasPage } = usePortalConfig();
  const { data, isLoading, error, refetch } = useSystemSettingsQuery();

  if (isLoading || error || !data) {
    return (
      <div className="mx-auto max-w-2xl space-y-6">
        <SettingsPageHeader
          title="Проверка заказов"
          subtitle="Организации в фильтре, склады-фулфилменты, паллетные листы и фотофиксация."
        />
        <LoadState
          isLoading={isLoading}
          error={error}
          onRetry={() => void refetch()}
          className="flex flex-col items-center gap-3 p-4 text-center"
        />
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-2xl space-y-6">
      <SettingsPageHeader
        title="Проверка заказов"
        subtitle="Организации в фильтре, склады-фулфилменты, паллетные листы и фотофиксация."
      />
      <OrgWhitelistCard
        title="Организации в фильтре «Проверка заказов»"
        field="order_check_org_refs"
        current={data.order_check_org_refs}
      />
      {hasPage("transfer_check") && (
        <OrgWhitelistCard
          title="Склады-фулфилменты"
          description={
            "Перемещения НА эти склады собираются как заказы покупателя — " +
            "паллетами, с фотофиксацией и палетным листом. Все остальные " +
            "перемещения остаются в разделе «Проверка перемещений». " +
            "Пустой список ничего не меняет."
          }
          field="fulfilment_warehouse_refs"
          current={data.fulfilment_warehouse_refs}
          searchFn={(q) => searchStructuralUnits("Склад", q)}
          queryKey="ff-warehouses"
          entityLabel="склады"
        />
      )}
      <TemplateBindingsCard />
      <PalletPhotoCard current={data.pallet_photo_required} />
    </div>
  );
}
